import { useRouterState, type AnyRouter } from "@tanstack/react-router";
import type { JSX, ReactNode } from "react";

import { BootShell } from "./BootShell";

/**
 * The router's `InnerWrap`. Until the root route's first load settles, the
 * router renders nothing: its top-level Suspense fallback is
 * `defaultPendingComponent`, left unset so routes don't inherit a pending UI.
 * This shows the boot shell for that window, so the page never goes blank
 * between index.html's shell and the first route's own pending component. On
 * later navigations the root match stays loaded.
 */
export const BootShellUntilRootLoads = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  // Typed against AnyRouter: the registered router type includes this wrapper.
  const isRootPending = useRouterState<AnyRouter, boolean>({
    select: ({ matches: [root] }) =>
      !root || root.status === "pending" || root.status === "redirected",
  });

  return (
    <>
      {children}
      {isRootPending && <BootShell />}
    </>
  );
};
